import { render, staticRenderFns } from "./mailbox-verification-instructions-microsoft.vue?vue&type=template&id=f49428b0&"
import script from "./mailbox-verification-instructions-microsoft.vue?vue&type=script&lang=ts&"
export * from "./mailbox-verification-instructions-microsoft.vue?vue&type=script&lang=ts&"
import style0 from "./mailbox-verification-instructions-microsoft.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports